var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3942 4.098C1.26491 3.96871 1.08955 3.89607 0.906708 3.89607C0.723862 3.89607 0.548505 3.96871 0.419213 4.098C0.289921 4.22729 0.217285 4.40265 0.217285 4.5855C0.217285 4.76834 0.289921 4.9437 0.419213 5.07299L2.47905 7.13283C2.54321 7.19647 2.6193 7.24682 2.70295 7.28099C2.78661 7.31515 2.87619 7.33247 2.96655 7.33195C3.06055 7.32897 3.15293 7.30671 3.23797 7.26655C3.32301 7.2264 3.39889 7.1692 3.46091 7.0985L8.26721 1.60559C8.37819 1.46781 8.4317 1.2925 8.41658 1.11623C8.40146 0.939958 8.31889 0.776323 8.18607 0.659445C8.05326 0.542567 7.88045 0.481467 7.70369 0.488886C7.52692 0.496304 7.35984 0.571667 7.23729 0.699263L2.96655 5.64288L1.3942 4.098Z",
    fill: "#7C879D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDropdown);
export default __webpack_public_path__ + "static/media/Check-dropdown.ea5b86ee8609a65152df36177694572a.svg";
export { ForwardRef as ReactComponent };